<div class="btn-group btn-group-sm" role="group" aria-label="Button Group for Transform Control's different Modes">
  @if (translation) {
    <input type="radio" class="btn-check" [name]="id" #translate [id]="'translate' + id"
      autocomplete="off" (click)="setMode('translate')" checked>
  }
  @if (translation) {
    <label class="btn btn-outline-light" [for]="'translate' + id" title="Translate">
      <i class="fas fa-arrows-alt"></i>
    </label>
  }

  @if (rotation) {
    <input type="radio" class="btn-check" [name]="id" #rotate [id]="'rotate' + id" autocomplete="off"
      (click)="setMode('rotate')">
  }
  @if (rotation) {
    <label class="btn btn-outline-light" [for]="'rotate' + id" title="Rotate">
      <i class="fas fa-sync-alt"></i>
    </label>
  }

  @if (scale) {
    <input type="radio" class="btn-check" [name]="id" #scale [id]="'scale' + id" autocomplete="off"
      (click)="setMode('scale')">
  }
  @if (scale) {
    <label class="btn btn-outline-light" [for]="'scale' + id" title="Scale">
      <i class="fas fa-expand-alt"></i>
    </label>
  }
</div>